module.exports = __webpack_public_path__ + "static/media/graduate-3.0e649997.png";